<div
  class="vendor-dialog"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
>
  <header class="vendor-dialog-header" cdkDragHandle>
    <img src="assets/images/new-images/logo-2.png" alt="aquila" />
    <h2 i18n="@@add_new_vendor_dealer">Add New Vendor/Dealer</h2>
    <button
      mat-icon-button
      type="button"
      class="vendor-dialog-close"
      (click)="cancel()"
      aria-label="Close dialog"
      i18n-aria-label="@@close_dialog"
    >
      <mat-icon>highlight_off</mat-icon>
    </button>
  </header>

  <form [formGroup]="vendorForm" (ngSubmit)="save()" class="vendor-dialog-body">
    <section class="vendor-profile-panel">
      <h3 i18n="@@vendor_dealer_profile">Vendor/Dealer Profile</h3>

      <div class="vendor-fields vendor-fields-name">
        <label class="vendor-field vendor-name-field">
          <span><span i18n="@@vendor_dealer_name">Vendor/Dealer Name</span> <strong>*</strong></span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <input matInput type="text" formControlName="name" />
            <mat-error *ngIf="showError('name')">{{ errorFor('name') }}</mat-error>
          </mat-form-field>
        </label>
        <label class="vendor-field">
          <span i18n="@@business_registration_number">Business Registration No.</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <input matInput type="text" formControlName="businessRegistrationNumber" />
          </mat-form-field>
        </label>
      </div>

      <div class="vendor-fields vendor-fields-address">
        <label class="vendor-field">
          <span i18n="@@country">Country</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <mat-select
              formControlName="country"
              (selectionChange)="onCountryChange($event.value)"
            >
              
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="countrySearch"
                  placeholderLabel="Search country..."
                  noEntriesFoundLabel="No matching country"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let country of countries | filterOptions: (countrySearch.value || '')" [value]="country.code">
                {{ country.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="showError('country')">{{ errorFor('country') }}</mat-error>
          </mat-form-field>
        </label>
        <label class="vendor-field">
          <span i18n="@@state">State</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <mat-select
              formControlName="state"
              (selectionChange)="onStateChange($event.value)"
            >
              
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="stateSearch"
                  placeholderLabel="Search state..."
                  noEntriesFoundLabel="No matching state"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let state of states | filterOptions: (stateSearch.value || '')" [value]="state.code">
                {{ state.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="showError('state')">{{ errorFor('state') }}</mat-error>
          </mat-form-field>
        </label>
        <label class="vendor-field">
          <span i18n="@@town_city">Town/City</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <mat-select formControlName="townCity">
              
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="citySearch"
                  placeholderLabel="Search town/city..."
                  noEntriesFoundLabel="No matching town or city"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let city of cities | filterOptions: (citySearch.value || '')" [value]="city.code">
                {{ city.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="showError('townCity')">{{ errorFor('townCity') }}</mat-error>
          </mat-form-field>
        </label>
        <label class="vendor-field">
          <span i18n="@@business_address">Business Address</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <input matInput type="text" formControlName="businessAddress" />
          </mat-form-field>
        </label>
      </div>

      <div class="vendor-fields vendor-fields-contact">
        <label class="vendor-field">
          <span i18n="@@contact_person">Contact Person</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <input matInput type="text" formControlName="contactPerson" />
            <mat-error *ngIf="showError('contactPerson')">{{ errorFor('contactPerson') }}</mat-error>
          </mat-form-field>
        </label>
        <div class="vendor-field vendor-telephone-field">
          <span i18n="@@telephone">Telephone</span>
          <mat-form-field
            appearance="outline"
            class="vendor-mat-field vendor-phone-field"
          >
            <input
              class="hidden"
              value="prevent_mat_form_throwing_missing_matInput_errors"
              matInput
            />
            <ngx-intl-tel-input
              appRemoveLeadingZero
              [cssClass]="'bg-transparent w-full'"
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="false"
              [searchCountryFlag]="true"
              [selectFirstCountry]="false"
              [selectedCountryISO]="currencyFormatter.tenantCountryISO"
              [separateDialCode]="true"
              [maxLength]="15"
              [phoneValidation]="true"
              [numberFormat]="PhoneNumberFormat.National"
              name="vendor telephone"
              formControlName="telephone"
            ></ngx-intl-tel-input>
          </mat-form-field>
        </div>
        <label class="vendor-field">
          <span i18n="@@email">Email</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <input matInput type="email" formControlName="email" />
            <mat-error *ngIf="showError('email')">{{ errorFor('email') }}</mat-error>
          </mat-form-field>
        </label>
      </div>

      <div class="vendor-fields vendor-fields-bank">
        <label class="vendor-field">
          <span i18n="@@bank_name">Bank Name</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <mat-select
              formControlName="bankCode"
              (selectionChange)="onBankChange($event.value)"
            >
              
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="bankSearch"
                  placeholderLabel="Search bank..."
                  noEntriesFoundLabel="No matching bank"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let bank of banks | filterOptions: (bankSearch.value || '')" [value]="bank.code">
                {{ bank.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="showError('bankCode')">{{ errorFor('bankCode') }}</mat-error>
          </mat-form-field>
        </label>
        <label class="vendor-field">
          <span i18n="@@account_number">Account Number</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <input matInput type="text" formControlName="accountNumber" />
            <mat-error *ngIf="showError('accountNumber')">{{ errorFor('accountNumber') }}</mat-error>
          </mat-form-field>
        </label>
        <label class="vendor-field">
          <span i18n="@@account_name">Account Name</span>
          <mat-form-field appearance="outline" class="vendor-mat-field">
            <input matInput type="text" formControlName="accountName" />
            <mat-error *ngIf="showError('accountName')">{{ errorFor('accountName') }}</mat-error>
          </mat-form-field>
        </label>
      </div>

      <div class="asset-category-section">
        <div class="asset-category-overview">
          <h3 class="asset-category-heading" i18n="@@asset_categories_supplied">
            Asset Categories Supplied
          </h3>

          <div class="asset-category-scroll">
            <div class="asset-category-list">
              <div class="asset-category" *ngFor="let category of assetCategories; let i = index">
                <mat-form-field appearance="outline" class="vendor-mat-field asset-category-label">
                  <input matInput type="text" [value]="category" readonly />
                </mat-form-field>
                <button
                  type="button"
                  class="asset-category-delete"
                  (click)="removeAssetCategory(i)"
                  aria-label="Remove category"
                  i18n-aria-label="@@remove_asset_category"
                >
                  <img src="assets/icons/delete-bin.svg" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="asset-category-add">
          <label i18n="@@name">Name</label>
          <mat-form-field appearance="outline" class="vendor-mat-field asset-category-name-field">
            <input
              matInput
              type="text"
              [formControl]="newCategoryControl"
              (keyup.enter)="addAssetCategory()"
            />
          </mat-form-field>
          <button type="button" (click)="addAssetCategory()">
            <mat-icon>add</mat-icon>
            <span i18n="@@add_asset_category">Add Asset Category</span>
          </button>
        </div>
      </div>
    </section>

    <footer class="vendor-dialog-actions">
      <button type="button" class="vendor-cancel" (click)="cancel()" i18n="@@cancel">Cancel</button>
      <button type="submit" class="vendor-save" [disabled]="saving" i18n="@@save">Save</button>
    </footer>
  </form>
</div>
